import FieldLayout from '../Layout/FieldLayout';
import Label from './Label';
interface IToggleInput {
  label: string;
  id: string;
  className: string;
  required?: boolean;
  fieldStyle?: string;
}
const ToggleInput = ({
  label,
  id,
  className,
  required,
  fieldStyle,
  ...rest
}: IToggleInput) => {
  return (
    <FieldLayout fieldStyle={fieldStyle}>
      {' '}
      <Label labelClassname="form-label d-block " id="isActive">
        {label}
        {required && <span className="text-danger">*</span>}
      </Label>
      <div className="form-check form-switch d-flex">
        <input
          {...rest}
          type="checkbox"
          style={{ cursor: 'pointer' }}
          id={id}
          className={className}
        />
      </div>
    </FieldLayout>
  );
};
export default ToggleInput;
